// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2X4Qe","delete":"styles_delete__25XxK","update":"styles_update__-sh3-","add":"styles_add__T7G-m"};